import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { InvoiceNumberSequence, InvoiceNumberSequenceSupplier } from '@synergy/models';
import { noop } from '@synergy/utils';

import { InvoiceNumberSequenceRequest } from '../../features/configuration/finance/invoice-number-sequence/models/invoice-number-sequence-request';
import { Prefix } from '../models/prefix';

export class InvoiceNumberSequenceApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<InvoiceNumberSequence>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/invoice-number-sequences`, { params }),
            response => response.data
        );

    public cgetAll = async (params?: URLSearchParams): Promise<ApiResult<InvoiceNumberSequence>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/invoice-number-sequences/all`, { params }),
            response => response.data
        );

    public getAvailableSuppliers = async (
        params?: URLSearchParams
    ): Promise<ApiResult<InvoiceNumberSequenceSupplier[]>> =>
        safeRequest(
            () =>
                request.get(`${this.baseUrl}/invoice-number-sequences/available-suppliers`, {
                    params,
                }),
            response => response.data
        );

    public deleteInvoiceNumberSequence = async (id: number): Promise<ApiResult<void>> =>
        safeRequest(() => request.delete(`${this.baseUrl}/invoice-number-sequences/${id}`), noop);

    public updateInvoiceNumberSequence = async (
        id: number,
        body: InvoiceNumberSequenceRequest,
        isDefault: boolean
    ): Promise<ApiResult<InvoiceNumberSequenceRequest>> =>
        safeRequest(
            () =>
                request.patch(`${this.baseUrl}/invoice-number-sequences/${id}`, {
                    ...body,
                    prefix: isDefault ? body.prefix ?? null : body.prefix,
                }),
            response => response.data
        );

    public createInvoiceNumberSequence = async (
        invoiceNumberSequence: InvoiceNumberSequenceRequest
    ): Promise<ApiResult<InvoiceNumberSequenceRequest>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/invoice-number-sequences`, invoiceNumberSequence),
            response => response.data
        );

    public getInvoiceNumberSequenceHistory = async (search?: string): Promise<ApiResult<Prefix[]>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/invoice-number-sequences/history`, { params: { search } }),
            response => response.data
        );

    public getInvoiceNumberSequenceSupplierHistory = async (
        id: number,
        search?: string
    ): Promise<ApiResult<Prefix[]>> =>
        safeRequest(
            () =>
                request.get(`${this.baseUrl}/invoice-number-sequences/supplier-history/${id}`, { params: { search } }),
            response => response.data
        );
}
